import { Form, ErrorMessage } from "@/shared/components";
import LinearProgress from "@mui/material/LinearProgress";
import { useQuery } from "@apollo/client";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

interface FilterFormProps {
  onSubmit: (values: any) => void;
  initialValues?: Record<string, any>;
  schema: any;
  title?: string;
}

function FilterForm({
  onSubmit,
  initialValues,
  schema,
  title,
}: FilterFormProps) {
  return (
    <Box>
      {title && (
        <Typography variant="h5" sx={{ mb: 2 }}>
          {title}
        </Typography>
      )}

      <Form
        initialValues={initialValues}
        schema={schema}
        onSubmit={onSubmit}
        submitButtonText="Поиск"
        resetButton={undefined}
        spacing={2}
      />
    </Box>
  );
}

interface FilterWithQueryProps extends FilterFormProps {
  query: any;
  variables?: Record<string, any>;
}

function FilterWithQuery({
  query,
  variables,
  onSubmit,
  initialValues,
  schema,
  title,
}: FilterWithQueryProps) {
  const { data, loading, error } = useQuery(query, { variables });

  if (loading) return <LinearProgress />;
  if (error) return <ErrorMessage error={error} />;

  return (
    <FilterForm
      initialValues={initialValues}
      schema={typeof schema === "function" ? schema(data) : schema}
      onSubmit={onSubmit}
      title={title}
    />
  );
}

interface FilterProps extends FilterFormProps {
  query?: any;
  variables?: Record<string, any>;
}

export function Filter({
  query,
  variables,
  onSubmit,
  initialValues,
  schema,
  title,
}: FilterProps) {
  if (query) {
    return (
      <FilterWithQuery
        query={query}
        variables={variables}
        initialValues={initialValues}
        schema={schema}
        onSubmit={onSubmit}
        title={title}
      />
    );
  }

  return (
    <FilterForm
      initialValues={initialValues}
      schema={schema}
      onSubmit={onSubmit}
      title={title}
    />
  );
}
